import React from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';

interface RTLWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function RTLWrapper({ children, className }: RTLWrapperProps) {
  const { isRTL, language } = useLanguage();

  return (
    <div 
      className={cn(
        'rtl-wrapper',
        isRTL && 'rtl',
        className
      )}
      dir={isRTL ? 'rtl' : 'ltr'}
      lang={language}
    >
      {children}
    </div>
  );
}